import { render, staticRenderFns } from "./WorkflowDetailViewComponent.vue?vue&type=template&id=bc753d0a&scoped=true&"
import script from "./WorkflowDetailViewComponent.vue?vue&type=script&lang=ts&"
export * from "./WorkflowDetailViewComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowDetailViewComponent.vue?vue&type=style&index=0&id=bc753d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc753d0a",
  null
  
)

export default component.exports